<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">
        {{ $t('attendance.edit_my_fingerspot_attendance') }}
      </oxd-text>
      <oxd-divider />
      <oxd-form :loading="isLoading" @submit-valid="onSave">
        <oxd-grid :cols="4" class="orangehrm-full-width-grid">
          <oxd-grid-item>
            <oxd-input-field
              v-model="fingerspotAttendance.ioMode"
              type="select"
              :label="$t('attendance.attendance_io_mode')"
              :options="ioMode"
              :show-empty-selector="false"
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <oxd-input-field
              v-model="fingerspotAttendance.scanDate.date"
              :label="$t('general.time')"
              disabled
            />
          </oxd-grid-item>
        </oxd-grid>

        <oxd-divider />
        <oxd-form-actions>
          <required-text />
          <oxd-button
            display-type="ghost"
            :label="$t('general.cancel')"
            @click="onCancel"
          />
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>

<script>
import {navigate} from '@ohrm/core/util/helper/navigation';
import {APIService} from '@ohrm/core/util/services/api.service';
import moment from 'moment/moment';
import usei18n from '@/core/util/composable/usei18n';

const fingerspotAttendanceModel = {
  id: null,
  pin: '',
  workCode: '',
  sn: '',
  verifyMode: '',
  scanDate: {
    date: '',
    timezone_type: null,
    timezone: '',
  },
  ioMode: '',
  status: null,
  employee: {
    empNumber: null,
    employeeId: '',
    firstName: '',
    lastName: '',
    fullName: '',
  },
};
export default {
  props: {
    fingerspotId: {
      type: String,
      required: true,
    },
  },
  setup() {
    const {$t} = usei18n();
    const ioMode = [
      {
        id: 1,
        value: '1',
        label: $t('attendance.punch_in'),
      },
      {
        id: 2,
        value: '2',
        label: $t('attendance.punch_out'),
      },
    ];
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/attendance/my-fingerspot-records',
    );
    return {
      http,
      ioMode,
    };
  },
  data() {
    return {
      isLoading: false,
      fingerspotAttendance: {...fingerspotAttendanceModel},
    };
  },
  created() {
    this.isLoading = true;
    this.http
      .get(this.fingerspotId)
      .then((response) => {
        const {data} = response.data;
        this.fingerspotAttendance.id = data.id;
        this.fingerspotAttendance.pin = data.pin;
        this.fingerspotAttendance.scanDate.date = moment(
          data.scanDate.date,
          'YYYY-MM-DD HH:mm:ss.SSSSSS',
        ).format('dddd, D MMMM YYYY hh:mm:ss A');
        this.fingerspotAttendance.ioMode = this.ioMode.find(
          (opt) => opt.value === data.ioMode,
        );
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    onSave() {
      this.isLoading = true;
      this.http
        .update(this.fingerspotId, {
          ioMode: this.fingerspotAttendance.ioMode.value,
        })
        .then(() => {
          return this.$toast.updateSuccess();
        })
        .then(() => {
          this.onCancel();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onCancel() {
      navigate('/attendance/viewMyFingerspotRecord');
    },
  },
};
</script>
